// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__yjrR4","spin":"Loader_spin__q8W71","center":"Loader_center__hu3tJ","big":"Loader_big__k3BR-","small":"Loader_small__MHFUu","medium":"Loader_medium__OHWLQ"};